module.exports = __webpack_public_path__ + "media/images/icons/star-pink-full-16ef74b2ee200e74a68e7c0ca9a16d2d.svg";